<div class="bmc-sync-data__container">

    <div class="bmc-sync-data">
    </div>
    <p>
      {{'SYNC_FILES.IMPORT_DESCRIPTION' | translate}}
    </p>
    <div>
    <bzg-button-primary  class="bmc-sync-data__button" (click)="onImport()">
      {{'SYNC_FILES.IMPORT_FILES' | translate}}
    </bzg-button-primary>
    </div>
  
  </div>
  
  <div class="bmc-sync-data__container-data">
    <ng-template #importTemplate>
      <biz-import-sync-files-modal class="bmc-modal" (onFinish)="closeModal()"></biz-import-sync-files-modal>
    </ng-template>
  
    <biz-sync-files-history [data]="importHistory" [isExport]="false"></biz-sync-files-history>
  </div>
  